@if (!errorState() && pet) {
    <div class="pet-details" [style.background-image]="pet.Background ? 'url(' + pet.Background.ImagePath + ')' : null">
        <img class="pet-image" [src]="pet.ImagePath" />
        <b>{{ pet.Name }}</b>
        <div>{{ pet.Color.Name }} {{ pet.Species.Name }}</div>
        <div class="hungerDisplay">{{ pet.FoodLevel }}</div>
        <div class="hungerDisplay">{{ pet.Mood }}</div>
        @if (ownedByViewer && featureFlagService.isFlagOpen('fishbowl', false)) {
            <button type="button" class="btn btn-outline-dark btn-sm" (click)="openBackgroundPicker()">Edit Background</button>
        }
    </div>
} @else {
    @if (errorState()) {
        <div>Oh man, this pet went missing!</div>
    } @else {
        Loading...
    }
}
